const features = [
  {
    icon: 'ri-flashlight-line',
    title: '每日极速更新',
    description: '与韩国原版同步更新，第一时间推送最新话，追更不等待，精彩不错过。',
  },
  {
    icon: 'ri-image-line',
    title: '高清全彩画质',
    description: '全彩高清漫画，还原原版精美画风，每一格画面都纤毫毕现，沉浸式阅读体验。',
  },
  {
    icon: 'ri-brain-line',
    title: '智能个性化推荐',
    description: '基于阅读偏好智能推荐，精准发现你喜欢的漫画，探索更多精彩作品。',
  },
];

export default function FeatureGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <span className="inline-block text-xs font-label text-foreground-500 uppercase tracking-wider mb-3">
            平台优势
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
            为什么选择
            <br />
            韩漫漫画网
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-background-50 rounded-2xl p-8 md:p-10 transition-all duration-300 hover:bg-background-50"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-500 mb-5 group-hover:scale-110 transition-transform duration-300">
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}